import React from 'react';
import { ContentfulSearchContent } from '@jbhi-fi/apis/src/contentful/types';
import { CollectionTransformer } from './CollectionTransformer';
import { AssetTransformer } from './AssetTransformer';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';

export type SearchContentProps = {
  title: string;
  url?: string;
  handle?: string;
  image?: React.ReactNode;
  destination?: string;
};
export abstract class SearchContentTransformer {
  static toSearchContentProps = (entries: Array<ContentfulSearchContent>): Array<SearchContentProps> => {
    return entries?.map(entry => {
      const imageProps = AssetTransformer.toContentfulImageProps(entry?.fields?.image);

      const searchContentProps = {
        title: entry?.fields?.title || '',
        url: entry?.fields?.url,
        handle: entry?.fields?.handle,
        image: <ContentfulImage {...imageProps} aspectRatio={1} />,
        destination: !entry?.fields?.url ? CollectionTransformer.toHref(entry.fields?.destination) : undefined,
      };
      return searchContentProps;
    });
  };
}
